import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=18c4cd28&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=18c4cd28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c4cd28",
  null
  
)

export default component.exports